export enum GitlockPermissionEnum {
  // plugin_view
  plugin_view = 'plugin_view',
  // repo_add
  repo_add = 'repo_add',
  // repo_delete
  repo_delete = 'repo_delete',
  // repo_modify
  repo_modify = 'repo_modify',
  // repo_view
  repo_view = 'repo_view',
}

export enum AlabinPermissionEnum {
  // bug库编辑权限
  bug_modify = 'bug_modify',
  // 管理中心页面权限
  manage_view = 'manage_view',
  // 快捷创建外放权限
  release_add = 'release_add',
  // 外放管理删除权限
  release_delete = 'release_delete',
}

export enum DummyfilePermissionEnum {
  // 函数库页面
  func_view = 'func_view',
  // wifi页面
  wifi_view = 'wifi_view',
}

export enum PackagemanagePermissionEnum {
  permission_manage = 'permission_manage',
  patch_env_delete = 'patch_env_delete',
  patch_env_modify = 'patch_env_modify',
  patch_env_add = 'patch_env_add',
  patch_record_delete = 'patch_record_delete',
  patch_filerecord_delete = 'patch_filerecord_delete',
  patch_file_delete = 'patch_file_delete',
  dev = 'dev',
  mirror = 'mirror',
  prod = 'prod',
}
